import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconChainSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.83 5.401a4.786 4.786 0 0 1 6.768 6.77l-1.07 1.07-.708.707-1.414-1.414.707-.707 1.071-1.07a2.786 2.786 0 0 0-3.94-3.941l-1.071 1.07-.707.708-1.414-1.415.707-.707 1.07-1.07Zm4.231 3.945-.707.707-5.3 5.301-.708.707-1.414-1.414.707-.707 5.3-5.301.708-.707 1.414 1.414Zm-7.467 2.12-.707.707-1.071 1.07a2.786 2.786 0 0 0 3.94 3.941l1.071-1.07.707-.708 1.414 1.414-.707.707-1.07 1.071A4.786 4.786 0 1 1 5.4 11.83l1.071-1.071.707-.707 1.415 1.414Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconChainSharp);
export default Memo;
